import { existingHeaders } from "./utils";

export const verificationService = {
  verify,
};

function verify(token) {
  const requestOptions = {
    method: "POST",
    headers: existingHeaders,
    body: JSON.stringify({ token: token }),
  };

  return fetch("/customer/email/verification", requestOptions).then(
    handleResponse
  );
}

function handleResponse(response) {
  if (!response.ok) {
    return Promise.reject(response.status);
  } else {
    return Promise.resolve(response);
  }
}
